import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
  structuredData,
  noindex = false
}) => {
  const siteName = 'TheLivCure';
  const baseUrl = 'https://thelivcure.com';
  const defaultImage = `${baseUrl}/image/seo_image.jpg`;
  const defaultDescription = "India's leading surgical care platform providing advanced, minimally invasive treatments with personalized patient care and world-class medical expertise.";
  
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const fullDescription = description || defaultDescription;
  const fullImage = image ? (image.startsWith('http') ? image : `${baseUrl}${image}`) : defaultImage;
  const fullUrl = url ? `${baseUrl}${url}` : baseUrl;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Additional SEO Meta Tags */}
      <meta name="author" content="TheLivCure" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#059669" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />
      {fullImage && <meta property="og:image" content={fullImage} />}
      {fullImage && <meta property="og:image:secure_url" content={fullImage} />}
      {fullImage && <meta property="og:image:width" content="1200" />}
      {fullImage && <meta property="og:image:height" content="630" />}
      {fullImage && <meta property="og:image:alt" content={title || siteName} />}
      {fullImage && <meta property="og:image:type" content="image/jpeg" />}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@thelivcure" />
      <meta name="twitter:creator" content="@thelivcure" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      {fullImage && <meta name="twitter:image" content={fullImage} />}
      {fullImage && <meta name="twitter:image:alt" content={title || siteName} />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Favicon and Icons */}
      <link rel="icon" type="image/png" sizes="32x32" href="/image/img_icon.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/image/img_icon.png" />
      <link rel="apple-touch-icon" href="/image/img_icon.png" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
